import React from 'react';
import { Instagram, Twitter, Facebook } from 'lucide-react';
export function Footer() {
  return <footer id="contact" className="relative w-full overflow-hidden pt-24 pb-12 px-6 md:px-12 border-t border-white/20" data-id="element-55">
      <div className="max-w-7xl mx-auto" data-id="element-56">
        {/* Main Footer: Content Left + Logo Right */}
        <div className="flex flex-col md:flex-row items-start gap-16 mb-16" data-id="element-57">
          {/* Left Side — Footer Content */}
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-12" data-id="element-58">
            {/* Brand Col */}
            <div className="sm:col-span-1" data-id="element-59">
              <h3 className="font-syncopate font-bold text-xl text-black tracking-wider mb-6" data-id="element-60">
                GLOSS & CHROME
              </h3>
              <p className="text-black/60 font-light max-w-sm mb-8" data-id="element-61">
                Elevating nail artistry through futuristic design, premium
                materials, and an unparalleled salon experience.
              </p>
              <div className="flex space-x-4" data-id="element-62">
                <a href="#" className="w-10 h-10 rounded-full glass-panel flex items-center justify-center text-black hover:bg-white/40 transition-colors" data-id="element-63">
                  <Instagram size={18} data-id="element-64" />
                </a>
                <a href="#" className="w-10 h-10 rounded-full glass-panel flex items-center justify-center text-black hover:bg-white/40 transition-colors" data-id="element-65">
                  <Twitter size={18} data-id="element-66" />
                </a>
                <a href="#" className="w-10 h-10 rounded-full glass-panel flex items-center justify-center text-black hover:bg-white/40 transition-colors" data-id="element-67">
                  <Facebook size={18} data-id="element-68" />
                </a>
              </div>
            </div>

            {/* Links Col 1 */}
            <div data-id="element-69">
              <h4 className="font-syncopate font-bold text-sm text-black tracking-widest mb-6" data-id="element-70">
                EXPLORE
              </h4>
              <ul className="space-y-4" data-id="element-71">
                <li data-id="element-72">
                  <a href="#services" className="text-black/60 hover:text-black transition-colors font-light" data-id="element-73">
                    Services
                  </a>
                </li>
                <li data-id="element-74">
                  <a href="#the-space" className="text-black/60 hover:text-black transition-colors font-light" data-id="element-75">
                    The Space
                  </a>
                </li>
                <li data-id="element-76">
                  <a href="#collection" className="text-black/60 hover:text-black transition-colors font-light" data-id="element-77">
                    Collection
                  </a>
                </li>
                <li data-id="element-78">
                  <a href="#" className="text-black/60 hover:text-black transition-colors font-light" data-id="element-79">
                    Artists
                  </a>
                </li>
              </ul>
            </div>

            {/* Links Col 2 */}
            <div data-id="element-80">
              <h4 className="font-syncopate font-bold text-sm text-black tracking-widest mb-6" data-id="element-81">
                VISIT US
              </h4>
              <ul className="space-y-4 text-black/60 font-light" data-id="element-82">
                <li data-id="element-83">123 Chrome Avenue</li>
                <li data-id="element-84">Design District</li>
                <li data-id="element-85">Los Angeles, CA 90012</li>
                <li className="pt-4" data-id="element-86">
                  <a href="mailto:hello@glossandchrome.com" className="hover:text-black transition-colors" data-id="element-87">
                    hello@glossandchrome.com
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Right Side — Logo */}
          <div className="w-full md:w-80 lg:w-96 flex-shrink-0 flex items-center justify-center md:justify-end" data-id="element-88">
            <img src="https://cdn.magicpatterns.com/uploads/oDtmSpH67wG56QfBam544W/Gloss__Chrome_Logo_sin_fondo.png" alt="The Gloss & Chrome Lab" className="w-64 md:w-full max-w-xs md:max-w-sm object-contain drop-shadow-lg" data-id="element-89" />
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-black/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-90">
          <p className="text-black/50 text-sm font-light" data-id="element-91">
            © {new Date().getFullYear()} The Gloss & Chrome Lab. All rights
            reserved.
          </p>
          <div className="flex space-x-6 text-sm text-black/50 font-light" data-id="element-92">
            <a href="#" className="hover:text-black transition-colors" data-id="element-93">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-black transition-colors" data-id="element-94">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}